module.exports = __webpack_public_path__ + "img/banner-parcelamento.70b34bd4.png";